import React, { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"

export function Referral() {
	const [refData, setRefData] = useState(null)
	const data = useStaticQuery(graphql`
		query {
			allContentfulReferralCampaign {
				nodes {
					slug
					bannerMessage {
						childMarkdownRemark {
							html
						}
					}
					referralCode
				}
			}
		}
	`)

	useEffect(() => {
		if (typeof window !== "undefined") {
			const urlParams = new URLSearchParams(window.location.search)
			const ref = urlParams.get("ref")
			const utmSource = urlParams.get("utm_source")
			const utmMedium = urlParams.get("utm_medium")
			const utmCampaign = urlParams.get("utm_campaign")
			const utmId = urlParams.get("utm_id")

			// Always save referral and UTM information if either exists
			if (ref || utmSource || utmMedium || utmCampaign || utmId) {
				const referralInfo = {
					ref_source: ref,
					campaign_slug: null, // Will be updated if matching campaign found
					timestamp: new Date().toISOString(),
					referral_code: ref,
					utm: {
						source: utmSource,
						medium: utmMedium,
						campaign: utmCampaign,
						id: utmId,
					},
				}

				// If ref exists, try to find matching campaign
				if (ref) {
					const matchingCampaign = data.allContentfulReferralCampaign.nodes.find(
						(campaign) => campaign.referralCode === ref
					)

					if (matchingCampaign) {
						// Update campaign_slug if matching campaign found
						referralInfo.campaign_slug = matchingCampaign.slug
						// Set refData to show banner
						setRefData(matchingCampaign)

						// Push to dataLayer only if there's a matching campaign
						window.dataLayer = window.dataLayer || []
						window.dataLayer.push({
							event: "referral_banner_view",
							referral_code: ref,
							campaign_slug: matchingCampaign.slug,
							utm_source: utmSource,
							utm_medium: utmMedium,
							utm_campaign: utmCampaign,
							utm_id: utmId,
						})
					}
				}

				// Save referral info regardless of whether there's a matching campaign
				localStorage.setItem("referral_info", JSON.stringify(referralInfo))
			}
		}
	}, [data])

	// Only render if we have referral data (matching campaign found)
	if (!refData) return null

	return (
		<div className="referral-banner bg-gray-700">
			<div className="max-w-7xl flex justify-center items-center py-6 lg:max-w-full mx-auto px-4 sm:px-6">
				<div className="self-stretch text-center justify-start">
					<div
						className="text-center text-white dark-bg-richtext"
						dangerouslySetInnerHTML={{ __html: refData.bannerMessage.childMarkdownRemark.html }}
					/>
				</div>
			</div>
		</div>
	)
}

export default Referral
